import { Renderer2, Component, OnInit, Inject  } from '@angular/core';
import { Router }              from '@angular/router';
import { FormDataService }     from '../data/formData.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-final',
  templateUrl: './final.component.html',
  styleUrls: ['./final.component.scss']
})
export class FinalComponent implements OnInit {

  title = '';
  result: any;

  constructor(private _renderer2: Renderer2, private router: Router, public formDataService: FormDataService, @Inject(DOCUMENT) private _document: Document) {
  
  }

  ngOnInit(): void {
    this.result = this.formDataService.postToDynamics365();
    console.log("...is loading...");


    let script = this._renderer2.createElement('script');
        script.type = `text/javascript`;
        script.text = `gtag('event', 'conversion', { 'send_to': 'AW-654124883/e8trCI6Z5P0BENPO9LcC', 'value': 243.0, 'currency': 'EUR' })`;
    this._renderer2.appendChild(this._document.head, script);
    
  }

}


